import styled from "styled-components";

export const MissionListControlsStyled = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 24px 0;
  gap: 8px;
`;
